export type PurchaseOrderWorkspaceQueue = 'late' | 'dueThisWeek' | 'all';

export const PURCHASE_ORDER_WORKSPACE_QUEUES: ReadonlyArray<{
  id: PurchaseOrderWorkspaceQueue;
  label: string;
  emptyTitle: string;
  emptyDescription: string;
}> = [
  {
    id: 'late',
    label: 'Late',
    emptyTitle: 'Nothing is late',
    emptyDescription: 'Every open purchase order is still within its expected delivery date.',
  },
  {
    id: 'dueThisWeek',
    label: 'Due this week',
    emptyTitle: 'Nothing due this week',
    emptyDescription:
      'No open purchase orders have an expected delivery date in the next seven days.',
  },
  {
    id: 'all',
    label: 'All purchase orders',
    emptyTitle: 'No purchase orders yet',
    emptyDescription:
      'Create a purchase order from part selections to start tracking vendor fulfillment.',
  },
];
